import type { ReactNode } from 'react';

export function Switch({
  checked,
  onChange,
  label,
  disabled,
  'aria-describedby': describedBy,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: ReactNode;
  disabled?: boolean;
  'aria-describedby'?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className="nyk-ui-switch"
      disabled={disabled}
      aria-describedby={describedBy}
      onClick={() => onChange(!checked)}
    >
      <span className="nyk-ui-switch-track" />
      {label && <span>{label}</span>}
    </button>
  );
}
